<script lang="ts" setup>
  type Step = {
    label: string
    link?: string
  }

  defineProps<{
    steps: Step[]
  }>()
</script>

<template>
  <div class="c-breadcrumbs">
    <!-- initial step -->
    <template v-if="steps[0]">
      <a v-if="steps[0].link" :href="steps[0].link" class="simple-text-link step">{{ steps[0].label }}</a>

      <span v-else class="step">
        {{ steps[0].label }}
      </span>
    </template>

    <!-- each further step with a chevron -->
    <template v-for="step in steps.slice(1)" :key="step">
      <icon-ionic-chevron-forward
        class="icon-chevron-forward"
        color="var(--color-stroke-medium)"
        height="24"
        width="24"
      />

      <a v-if="step.link" :href="step.link" class="simple-text-link step">{{ step.label }}</a>

      <span v-else class="step">
        {{ step.label }}
      </span>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .c-breadcrumbs {
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;

    .icon-chevron-forward {
      color: var(--color-stroke-medium);
    }

    .step {
      @include typography-body-small;
    }
  }
</style>
